import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import { RESET_STORE } from '@/constants/store-mutation-types'

import config from 'SrcConfig'

// sub-views
import order from './order'
import supported from './supported'
import registerOrder from './register-order'
import location from './location'
import timeSheet from './time-sheet'
import record from './record'
import baseInfo from './base-info'
import feedback from './feedback'
import crm from './crm'
import message from './message'
import financial from './financial'
import courier from './courier'
import transport from './transport'
import user from './user'
import cms from './cms'
import security from './security'
import system from './system'
import log from './log'
import template from './template'
import site from './site-generator'
import questionnaire from './questionnaire'
import blog from './blog'
import branch from './branch'
// ----------
import Reports from './reports'
import external from './external'
import bol from './bol'

// layout
const Layout = () =>
  import(/* webpackChunkName: "layout" */ '@/components/layout/index.vue')

// main-views
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ '@/pages/dashboard.vue')
const Login = () => import(/* webpackChunkName: "login" */ '@/pages/login.vue')
const ForgotPassword = () =>
  import(
    /* webpackChunkName: "forgot-password" */ '@/pages/forgot-password.vue'
  )
const Page404 = () =>
  import(/* webpackChunkName: "page-404" */ '@/pages/404.vue')
const AccessDenied = () =>
  import(
    /* webpackChunkName: "page-access-denied" */ '@/pages/access-denied.vue'
  )

Vue.use(Router)

const options = {
  mode: 'history',
  linkActiveClass: 'open active',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'root',
      path: '/',
      redirect: config.homeUrl,
      meta: { label: 'Home' },
      component: Layout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: Login,
          meta: { title: 'account.Login', public: true }
        },
        // refactored
        order,
        supported,
        registerOrder,
        location,
        record,
        baseInfo,
        feedback,
        crm,
        message,
        financial,
        courier,
        user,
        transport,
        cms,
        security,
        system,
        timeSheet,
        // ----------
        Reports,
        log,
        template,
        site,
        questionnaire,
        blog,
        external,
        branch,
        bol
      ]
    },
    {
      name: 'AccessDenied',
      path: '/access-denied',
      component: AccessDenied
    },
    {
      name: 'catch-all',
      path: '*',
      component: Page404
    }
  ]
}

if (config.homeUrl === '/dashboard') {
  options.routes[0].children.push({
    name: 'dashboard',
    path: 'dashboard',
    meta: { title: 'nav.Dashboard', auth: true },
    component: Dashboard
  })
}

if (config.auth.forgotPasswordIsEnabled) {
  options.routes[0].children.push({
    name: 'ForgotPassword',
    path: 'forgot-password',
    meta: { title: 'account.forgotPassword', public: true },
    component: ForgotPassword
  })
}

const router = new Router(options)

// router.beforeEach((to, from, next) => {
//   if (
//     (to.name === 'RegisterOrder' && from.name !== 'RegisterOrderOperation') ||
//     (to.name === 'TemplateOrder' && from.name !== 'TemplateOrderOperation')
//   )
//     store.commit(RESET_STORE)
//   next()
// })

export default router
